import { domContentLoadEvent } from '../common/domContentLoadEvent';

function setupList() {
    const lists = document.querySelectorAll('.sideBySideList');

    lists.forEach((list) => {
        const leftColumn = list.querySelector('.left-column');
        const rightColumn = list.querySelector('.right-column');
        const items = list.querySelectorAll('.sideBySideListItem');

        // Mantém a altura de cada coluna o mais próximo possível
        items.forEach((item) => {
            const column = leftColumn.clientHeight <= rightColumn.clientHeight ? leftColumn : rightColumn;
            column.appendChild(item);
        });
    });
}

domContentLoadEvent(setupList);
